module.exports = __webpack_public_path__ + "img/blog-sample.da2e2d02.png";